import { createBrowserRouter } from "react-router";
import { AppLayout } from "./components/AppLayout";
import { OverviewModule } from "@/modules/overview";
import { ReconciliationModule } from "@/modules/reconciliation";
import { ReviewModule } from "@/modules/review";
import { UploadModule } from "@/modules/upload";

/**
 * Top-level route table. Each feature module owns everything below its path.
 *
 * The static bucket serves index.html for unknown paths (the backend bucket's
 * not_found_page), so a hard refresh on any of these works in production.
 */
export const router = createBrowserRouter([
  {
    path: "/",
    element: <AppLayout />,
    children: [
      { index: true, element: <OverviewModule /> },
      { path: "run", element: <UploadModule /> },
      { path: "review", element: <ReviewModule /> },
      { path: "reconciliation", element: <ReconciliationModule /> },
    ],
  },
]);
